<template>
  <div class="nav">
    <a-row class="nav-container">
      <a-col class="logo" :xs="24">
        <a href="https://asiacarto.org/2024/"><img src="@/assets/asiacarto.png" alt=""></a>
        <a href="https://icaci.org/"><img src="@/assets/organizers/ICA_header.png" alt=""></a>
        <a href="https://www.polyu.edu.hk/"><img src="@/assets/organizers/polyu_logo1-removebg-preview.png" alt=""></a>
        
      </a-col>
    </a-row>
    <a-row class="nav-container2">
      <a-col class="menu1" >
        <a-menu class="menu-container1" :selectedKeys="[$route.path]" mode="horizontal" theme="dark" @select="menuSelect">
          <a-menu-item :key="'/'">
            <router-link to="/" @click="scrollToTop">Welcome</router-link>
          </a-menu-item>
          <a-menu-item :key="'/keynote'">
            <router-link to="/keynote" @click="scrollToTop">Guests of Honor & Keynote Speakers</router-link>
          </a-menu-item>
          <a-menu-item :key="'/submission'">
            <router-link to="/submission" @click="scrollToTop">Submission</router-link>
          </a-menu-item>
          <a-menu-item :key="'/registration'">
            <router-link to="/registration" @click="scrollToTop">Registration</router-link>
          </a-menu-item>
          <a-menu-item :key="'/workshops'">
            <router-link to="/workshops" @click="scrollToTop">Workshops</router-link>
          </a-menu-item>
          <a-menu-item :key="'/programme'">
            <router-link to="/programme" @click="scrollToTop">Program</router-link>
          </a-menu-item>
          <a-menu-item :key="'/awards'">
            <router-link to="/awards" @click="scrollToTop">Awards</router-link> 
          </a-menu-item>
          <a-menu-item :key="'/sponsors'">
            <router-link to="/sponsors" @click="scrollToTop">Sponsors</router-link>
          </a-menu-item>
          <a-menu-item :key="'/committees'">
            <router-link to="/committees" @click="scrollToTop">Committee</router-link>
          </a-menu-item>
          <a-menu-item :key="'/accommodations'">
            <router-link to="/accommodations" @click="scrollToTop">Accommodation</router-link>
          </a-menu-item>
          <a-menu-item :key="'/venue'">
            <router-link to="/venue" @click="scrollToTop">Venue</router-link>
          </a-menu-item>
          <a-menu-item :key="'/contact'">
            <router-link to="/contact" @click="scrollToTop">Contact</router-link>
          </a-menu-item>
        </a-menu>        
      </a-col>
    </a-row>
  </div>

  <div class="nav2">
    <a-row class="nav-container" type="flex">
      <a-col class="logo" flex="100px">
        <a href="https://asiacarto.org/2024/" ><img src="@/assets/asiacarto_white.png" alt=""></a>
      </a-col>
      <a-col class="menu" flex="auto">
        <div class="small-menu">
          <!-- <a-button type="primary" @click="showDrawer"><MenuOutlined style="font-size: 1.5rem;"/></a-button> -->
          <button class="open-btn" @click="showDrawer"><MenuOutlined /></button>
          <a-drawer
            class="memu-drawer"
            title="Menu"
            placement="right"
            :closable="true"
            v-model:visible="visible"
            :after-visible-change="afterVisibleChange"
          >
            <a-menu class="menu-container2" :selectedKeys="[$route.path]" mode="inline" theme="dark" @select="menuSelect">
                <a-menu-item :key="'/'">
                  <router-link to="/" @click="scrollToTop">Welcome</router-link>
                </a-menu-item>
                <a-menu-item :key="'/keynote'">
                  <router-link to="/keynote" @click="scrollToTop">Guests of Honor & Keynote Speakers</router-link>
                </a-menu-item>
                <a-menu-item :key="'/submission'">
                  <router-link to="/submission" @click="scrollToTop">Submission</router-link>
                </a-menu-item>
                <a-menu-item :key="'/registration'">
                  <router-link to="/registration" @click="scrollToTop">Registration</router-link>
                </a-menu-item>
                <a-menu-item :key="'/workshops'">
                  <router-link to="/workshops" @click="scrollToTop">Workshops</router-link>
                </a-menu-item>
                <a-menu-item :key="'/programme'">
                  <router-link to="/programme" @click="scrollToTop">Program</router-link>
                </a-menu-item>
                <a-menu-item :key="'/awards'">
                  <router-link to="/awards" @click="scrollToTop">Awards</router-link>
                </a-menu-item>
                <a-menu-item :key="'/sponsors'">
                  <router-link to="/sponsors" @click="scrollToTop">Sponsors</router-link>
                </a-menu-item>
                <a-menu-item :key="'/committees'">
                  <router-link to="/committees" @click="scrollToTop">Committee</router-link>
                </a-menu-item>
                <a-menu-item :key="'/accommodations'">
                  <router-link to="/accommodations" @click="scrollToTop">Accommodation</router-link>
                </a-menu-item>
                <a-menu-item :key="'/venue'">
                  <router-link to="/venue" @click="scrollToTop">Venue</router-link>
                </a-menu-item>
                <a-menu-item :key="'/contact'">
                  <router-link to="/contact" @click="scrollToTop">Contact</router-link>
                </a-menu-item>
            </a-menu>
          </a-drawer>
        </div>
      </a-col>
    </a-row>
  </div>

  
</template>
<script>
import { useRouter } from 'vue-router';
import { defineComponent, ref,  } from 'vue';
import { MenuOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  setup() {
    const visible = ref(false);
    const router = useRouter();

    const afterVisibleChange = bool => {
      console.log('visible', bool);
    };

    const showDrawer = () => {
      visible.value = true;
    };

    router.afterEach(() => {
      visible.value = false;
    });
    
    return {
      visible,
      afterVisibleChange,
      showDrawer,
    };
  },
  components: {
    MenuOutlined
  },
  methods: {
    scrollToTop() {
      //console.log('Method scrollToTop is called!');
      window.scroll(0, 0);
    },
  },
});


</script>

<style lang="less" scoped>
 @import "./style.less" ;
</style>

 




